"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var PProgramAreaRoot = /** @class */ (function (_super) {
    __extends(PProgramAreaRoot, _super);
    function PProgramAreaRoot(props) {
        return _super.call(this, props) || this;
    }
    PProgramAreaRoot.prototype.render = function () {
        return (React.createElement("div", { style: {
                width: "100%",
                borderColor: "black",
                borderStyle: "solid",
                borderLeftWidth: "0px",
                borderTopWidth: "1px",
                borderRightWidth: "1px",
                borderBottomWidth: "1px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center"
            } }, "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0431\u0440\u044D\u043D\u0434 \u0438 \u043A\u0430\u0442\u0430\u043B\u043E\u0433 \u0434\u043B\u044F \u0432\u044B\u0431\u043E\u0440\u0430 \u043A\u043E\u043D\u0442\u0435\u043D\u0442\u0430"));
    };
    return PProgramAreaRoot;
}(React.Component));
exports.default = PProgramAreaRoot;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/dialogs/ui/dlgSelectPProgramImage/controls/PProgramAreaRoot.tsx
// module id = 2472
// module chunks = 0